import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateCourseTypeProperties extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseTypeProperty/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllCourseTypeProperties extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseTypeProperty/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateCourseTypeProperty extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseTypeProperty/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteCourseTypeProperty extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("CourseTypeProperty/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateCourseTypeProperties,
  GetAllCourseTypeProperties,
  UpdateCourseTypeProperty,
  DeleteCourseTypeProperty,
};
